(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-worlds-directory]:not([data-worlds-ready])').forEach(async (root) => {
      root.dataset.worldsReady = 'true';
      const rail = root.querySelector('[data-worlds-rail]');
      const previous = root.querySelector('[data-worlds-previous]');
      const next = root.querySelector('[data-worlds-next]');
      const sync = () => {
        const overflow = rail.scrollWidth > rail.clientWidth + 2;
        previous.hidden = !overflow; next.hidden = !overflow;
        previous.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      previous.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth * .8, behavior: reduced() ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth * .8, behavior: reduced() ? 'auto' : 'smooth' }));
      rail.addEventListener('scroll', sync, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(rail);
      sync();
      try {
        const response = await fetch(root.dataset.catalog, { credentials: 'omit' });
        if (!response.ok) return;
        const data = await response.json();
        if (data.schemaVersion !== 1 || data.purchaseEnabled !== false || !Array.isArray(data.products)) return;
        const preferred = { superheroes: 'Batman', cartoons: 'Adventure Time', music: 'Metallica', motorcycle: 'Honda', baseball: 'Portland', basketball: 'Baylor', college: 'Michigan' };
        const used = new Set();
        root.querySelectorAll('[data-world-story]').forEach((card) => {
          const candidates = data.products.filter((p) => p.verified === true && p.status === 'DRAFT' && p.purchaseEnabled === false && p.qualityVersion === 'v2-original-art-4096' && p.categories?.includes(card.dataset.worldStory));
          const product = candidates.find((p) => p.title === `Men's ${preferred[card.dataset.worldStory]} Hoodie Joggers Set`) || candidates.find((p) => !used.has(p.id)) || candidates[0];
          if (!product) return;
          used.add(product.id);
          const source = new URL(product.primaryImage);
          if (source.protocol !== 'https:' || source.hostname !== 'cdn.shopify.com') return;
          const img = card.querySelector('img');
          const sized = (width) => { const url = new URL(source); url.searchParams.set('width', String(width)); return url.href; };
          img.src = sized(540); img.srcset = [320, 540, 720].map((width) => `${sized(width)} ${width}w`).join(', ');
          img.sizes = '(max-width: 600px) 63vw, 260px'; img.alt = `${product.title} · ${product.primaryColor}`;
        });
      } catch (_) {}
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
